import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss']
})
export class Step1Component implements OnInit {

  @Output() step1ResultEvent = new EventEmitter<string>();

  step11 = false;
  step12 = false;
  step13 = false;
  step14 = false;
  step15 = false;
  step16 = false;
  step17 = false;
  step1Result: boolean;

  constructor(public translate: TranslateService) {
    translate.setDefaultLang("en");
  }

  ngOnInit() {

  }

  getstep1Result(value) {
    this.step1Result = value;
    this.step1ResultEvent.emit(value);
  }

}
